/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { styled } from "@mui/system";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Settings page components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import Sidenav from "./components/Sidenav";
import DataTable from "Tables/DataTable";
import EditSettlement from "Modals/EditSettlementNew";

// sweetalert2 components
import Swal from "sweetalert2";

// import BasicInfo from "./components/BasicInfo";
// import ChangePassword from "./components/ChangePassword";
// import DeleteAccount from "./components/DeleteAccount";

import { getData, postData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";
import { useSoftUIController } from "context";

import { Alert, Icon, Menu, Snackbar } from "@mui/material";
import NotificationItem from "components/Skill90NotificationItem";
import DownloadJSON from "components/DownloadJSON";
import SoftProgress from "components/SoftProgress";

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 500,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
    marginLeft: "15px",
  },
}));

let sport = "";
let uncheckedFixtures = {};
let checkedFixtures = {};
let sportsList = null;
let timeExceededRules = {
  soccer: 2.5,
  tabletennis: 1.5,
};

let oddSettingsEditCached = true;
let currentData = [];
let allTableData = [];

function Settlement() {
  const abortController = new AbortController();

  const [controller] = useSoftUIController();
  const { providers, sports, permissions } = controller;
  const [showEditModal, setEditModal] = useState(false);
  const [rowDataSelected, setRowDataSelected] = useState(null);
  const [showRefreshButton, setShowRefreshButton] = useState(false);
  const [sortByUnchecked, setSortByUnChecked] = useState(false);
  const [sidenavCollapse, setSidenavCollapse] = useState(false);
  const [workflow, setWorkflow] = useState(undefined);
  const [sportSelected, setSportSelected] = useState(null);
  const [openTimeline, setOpenTimeline] = useState(false);
  const [openScoreboard, setOpenScoreboard] = useState(false);
  const [selectedTimeline, setSelectedTimeline] = useState(null);
  const [selectedScoreboard, setSelectedScoreboard] = useState(null);
  const [timelineEvent, setTimelineEvent] = useState(null);
  const [settlementManager, setSettlementManager] = useState(false);
  const [fetching, setFetching] = useState(false);

  const [autoRefresh, setAutoRefresh] = useState(true);

  const [dataTableData, setDataTableData] = useState({
    columns: [
      { Header: "selected", accessor: "selected", width: "100px" },
      { Header: "Odds", accessor: "unsettled_odds", width: "80px", Cell: linkCell },
      { Header: "CheckedDiffs", accessor: "checkedOdds", width: "80px", Cell: checkedDiffs },
      { Header: "UnCheckedDiffs", accessor: "uncheckedOdds", width: "80px", Cell: uncheckedDiffs },
      { Header: "Diffs", accessor: "diffsOdds", width: "80px" },
      // { Header: "Provider", accessor: "provider_name", width: "110px", Cell: formatCell },
      { Header: "Sport", accessor: "sport", width: "80px", Cell: formatSport },
      { Header: "Status", accessor: "status", width: "100px", Cell: formatStatus },
      {
        Header: "Since",
        accessor: "finished_at_utc",
        width: "100px",
        Cell: formatStatusTime,
      },
      { Header: "Region", accessor: "region", width: "100px" },
      { Header: "Competition", accessor: "competition", width: "100px", Cell: formatCell },
      { Header: "Home", accessor: "home", width: "120px", Cell: formatParticipant },
      { Header: "Away", accessor: "away", width: "120px", Cell: formatParticipant },
      { Header: "Start Date", accessor: "start_date_utc", width: "100px", Cell: renderDate },
      // { Header: "Score", accessor: "inPlay", width: "120px", Cell: formatScore },
      { Header: "provider/ Uni id", accessor: "fixture_id", width: "100px", Cell: matchedRender },
    ],

    rows: [],
  });

  const [providersList, setProvidersList] = useState(providers || null);
  const [hiddenColumns, setHiddenColumns] = useState([
    "selected",
    "checkedOdds",
    "uncheckedOdds",
    "diffsOdds",
  ]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [updateEnabled, setUpdateEnabled] = useState(false);
  const [, setMutedIdsDict] = useState({});
  const [mutedFixtures, setMutedFixtures] = useState(null);
  const [outrightsFixtures, setOutrightsFixtures] = useState(null);
  const [unmutedFixtures, setUnmutedFixtures] = useState(null);
  const [mutedSelected, setMutedSelected] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [outrightSelected, setOutrightSelected] = useState(false);
  const [fixturesLoaded, setFixturesLoaded] = useState(false);
  const [mutedFixturesLoaded, setMutedFixturesLoaded] = useState(false);
  const [outrightsLoaded, setOutrightsLoaded] = useState(false);

  const [, setBlockedFixturesDict] = useState({});

  const statusSorting = {
    Finished: 0,
    "Coverage lost": 1,
    PreFinished: 1,
    Suspended: 2,
    "In progress": 3,
    "Not started yet": 4,
  };

  //setWorkflow(true);

  async function setSortBy() {
    let filter = sortByUnchecked;
    setSortByUnChecked(!filter);
  }

  async function setAutorefreshValue() {
    let filter = autoRefresh;
    setAutoRefresh(!filter);
  }

  function changeSorting(data) {
    setDataTableData({ columns: [], rows: [] });
    let dataTable = data ? data : { ...dataTableData };

    if (sortByUnchecked) dataTable.rows = dataTable.rows.sort((a, b) => b.diffsOdds - a.diffsOdds);
    if (sortByUnchecked == false) {
      dataTable.rows = dataTable.rows.sort((a, b) => {
        if (a.already_settled || b.already_settled) {
          return sortingByAlreadySettled(a, b);
        }
        if (a.status === "Finished" && b.status === "Finished") sortingByFinishtDate(a, b);
        return sortingByStartDate(a, b);
      });
    }

    setDataTableData(dataTable);
  }

  function sortingByAlreadySettled(a, b) {
    const sorting = Number(b.already_settled) - Number(a.already_settled);
    return sorting;
  }

  function sortingByStartDate(a, b) {
    let sorting = sortByStatus(a, b);
    if (sorting != 0) return sorting;
    sorting =
      a.start_date_utc - b.start_date_utc == 0
        ? sortBy(a.fixture_id, b.fixture_id)
        : sortBy(a.start_date_utc, b.start_date_utc);

    return sorting;
  }

  function sortingByFinishtDate(a, b) {
    let sorting = sortByStatus(a, b);
    if (sorting != 0) return sorting;
    sorting =
      a.finished_at_utc - b.finished_at_utc == 0
        ? sortBy(a.fixture_id, b.fixture_id)
        : sortBy(a.finished_at_utc, b.finished_at_utc);

    return sorting;
  }

  function sortByStatus(a, b) {
    if (statusSorting[a.status] < statusSorting[b.status]) {
      return -1;
    }
    if (statusSorting[a.status] > statusSorting[b.status]) {
      return 1;
    }
    return 0;
  }

  function sortBy(a, b) {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  }

  const handleSportChange = (sportId, sportName) => {
    // if (!providers) return;
    if (sportId) {
      let toClearData = false;
      if (!sportSelected || sportId !== sportSelected.id) {
        toClearData = true;
      }
      setSportSelected({ id: sportId, name: sportName });
      sport = sportName;
    } else {
      setShowRefreshButton(true);
    }
  };

  const handleSideNavCollapse = (collapse) => {
    setSidenavCollapse(collapse);
  };

  const handleTableDataChanges = async ({ key, value, extra }) => {
    if (key == "refresh") {
      // initData();
    }

    if (key == "selectOne") {
      setUpdateEnabled(false);
      setHiddenColumns([]);
      setDataTableData({ columns: [], rows: [] });

      let dataRow = currentData.rows.find((item) => item.id == value);
      dataRow.selected = extra;
      let rows = selectedRows ? selectedRows : [];
      let rowExist = rows.findIndex((item) => item.id == value);
      if (rowExist > -1) {
        if (!extra) {
          rows.splice(rowExist, 1);
          setSelectedRows(rows);
        }
      } else {
        if (extra) {
          rows.push(dataRow);
          setSelectedRows(rows);
        }
      }
      if (selectedRows.length > 0) setUpdateEnabled(true);

      setHiddenColumns(["selected", "checkedOdds", "uncheckedOdds", "diffsOdds"]);
      setDataTableData(currentData);
    }

    if (key == "selectAll") {
      setUpdateEnabled(false);
      setHiddenColumns([]);
      setDataTableData({ columns: [], rows: [] });
      let dataRows = currentData.rows;
      if (extra == "all") {
        dataRows = value;
        for (let index = 0; index < dataRows.length; index++) {
          const dataRow = dataRows[index];
          dataRow.selected = true;
        }
        setSelectedRows(dataRows);
      } else if (extra == "none") {
        dataRows = value;
        for (let index = 0; index < dataRows.length; index++) {
          const dataRow = dataRows[index];
          dataRow.selected = false;
        }
        setSelectedRows([]);
      }
      if (dataRows.filter((dr) => dr.selected).length > 0) setUpdateEnabled(true);

      setHiddenColumns(["selected", "checkedOdds", "uncheckedOdds", "diffsOdds"]);
      setDataTableData(currentData);
    }
  };

  async function fetchFixtures(sportId, clearTable) {
    setFetching(true);
    let id = null;
    if (sportId) {
      id = sportId;
    } else {
      id = sportSelected ? sportSelected.id : id;
    }
    if (!id) return;

    setFixturesLoaded(false);
    getSettlementConfig();

    const mutedIds = await fetchMutedFixtures();
    const blockedIds = await fetchBlockedFixtures();

    let getFixturesEndpoint = `/api/v2/panel/settlements/unsettled/sports/${id}/fixtures`;
    setShowRefreshButton(false);

    if (clearTable && sportSelected) {
      if (id !== sportSelected.id) {
        uncheckedFixtures = {};
        checkedFixtures = {};
      }
    }
    let response = await getData(
      getFixturesEndpoint,
      { Authorization: getAuthorizationHeader() },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    if (response != null) {
      let dataTable = { ...dataTableData };
      let mutedFixtures = [];
      let unmutedFixtures = [];

      for (let index = 0; index < response.data.length; index++) {
        const event = response.data[index];

        event.selected = false;
        switch (event.market_type) {
          case 1:
            event.fast_market = true;
            event.players_market = false;
            break;
          case 2:
            event.fast_market = false;
            event.players_market = true;
            break;
          case 3:
            event.fast_market = true;
            event.players_market = true;
            break;
          default:
            event.fast_market = false;
            event.players_market = false;
            break;
        }

        let minFinished = null;
        let hours = null;
        let minutes = null;
        let timestamp =
          event.status === "In progress" || event.status === "Not started yet"
            ? event.start_date_utc
            : event.finished_at_utc;
        if (timestamp) {
          let now = new Date();
          let finished_at = new Date(timestamp * 1);
          minFinished = now.getTime() - finished_at.getTime();
          minFinished = Math.round(minFinished / 1000 / 60);
          hours = Math.floor(minFinished / 60);
          minutes = minFinished - hours * 60;
          hours = hours < 10 ? "0" + hours : hours;
          minutes = minutes < 10 ? "0" + minutes : minutes;
        }

        if (!uncheckedFixtures[event.fixture_id]) {
          if (checkedFixtures[event.fixture_id]) {
            if (checkedFixtures[event.fixture_id] !== event.unsettled_odds) {
              uncheckedFixtures[event.fixture_id] =
                event.unsettled_odds - checkedFixtures[event.fixture_id];
            }
          } else {
            uncheckedFixtures[event.fixture_id] = event.unsettled_odds;
          }
        } else {
          if (checkedFixtures[event.fixture_id]) {
            uncheckedFixtures[event.fixture_id] =
              event.unsettled_odds - checkedFixtures[event.fixture_id];
          } else {
            uncheckedFixtures[event.fixture_id] = event.unsettled_odds;
          }
        }
        event.uncheckedOdds = uncheckedFixtures[event.fixture_id];
        event.checkedOdds = checkedFixtures[event.fixture_id];

        event.diffsOdds = checkedFixtures[event.fixture_id]
          ? event.unsettled_odds - checkedFixtures[event.fixture_id]
          : event.unsettled_odds;
        event.providerId = event.matched
          ? { value: 1000 }
          : providersList
          ? providersList.find((p) => p.info == event.provider_name)
          : providers.find((p) => p.info == event.provider_name);
        event.providerId = event.providerId.value;
        event.linkedsearch = event.linked ? "linked" : "";
        event.sport = sportsList.find((item) => item.id === event.sport_id).name;
        event.time_exceeded = hours
          ? timeExceededRules[event.sport.toLowerCase().replace(/ /g, "")]
            ? hours * 1 >= timeExceededRules[event.sport.toLowerCase().replace(/ /g, "")]
              ? true
              : false
            : false
          : false;

        event.blocked = blockedIds[`${event.providerId}:${event.fixture_id}`];

        if (event.matched) {
          if (mutedIds["1000:" + event.fixture_id]) {
            mutedFixtures.push(event);
          } else {
            unmutedFixtures.push(event);
          }
        } else {
          if (mutedIds[event.provider_name + ":" + event.fixture_id]) {
            mutedFixtures.push(event);
          } else {
            unmutedFixtures.push(event);
          }
        }
      }

      dataTable.rows = response.data;

      allTableData = { ...dataTable };
      currentData = { ...dataTable };

      setMutedFixtures({});
      setMutedFixtures({ columns: dataTable.columns, rows: mutedFixtures });
      setUnmutedFixtures({});
      setUnmutedFixtures({ columns: dataTable.columns, rows: unmutedFixtures });

      setFixturesLoaded(true);
      setFetching(false);
      await getOutrightsFixtures(id);
    }
  }

  async function getOutrightsFixtures(sportId) {
    let getOutrightsFixturesEndpoint = `/api/v1/bets/unsettled/sports/${sportId}/fixtures/outrights`;
    setOutrightsLoaded(false);
    let response = await getData(
      getOutrightsFixturesEndpoint,
      {
        Authorization: getAuthorizationHeader(),
      },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    if (response != null) {
      // let sport =
      //   response.data && response.data.length > 0
      //     ? sportsList.find((item) => item.id === response.data[0].sport_id).name
      //     : "";
      setOutrightsFixtures({
        columns: dataTableData.columns,
        rows: response.data
          .filter((f) => f.sport_id)
          .map((f) => {
            f.sport = sportsList.find((item) => item.id === f.sport_id).name;
            f.providerId = f.matched
              ? { value: 1000 }
              : providersList
              ? providersList.find((p) => p.info == f.provider_name)
              : providers.find((p) => p.info == f.provider_name);
            f.providerId = f.providerId.value;
            return f;
          }),
      });
    }
    setOutrightsLoaded(true);
  }

  async function fetchMutedFixtures() {
    let getMutedFixturesEndpoint = `/api/v1/bets/mutedFixtures`;

    let mutedIdsloaded = [];
    setMutedFixturesLoaded(false);
    let response = await getData(
      getMutedFixturesEndpoint,
      {
        Authorization: getAuthorizationHeader(),
      },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    if (response != null) {
      mutedIdsloaded = response.data.map((r) => {
        return r.event_key;
      });
    }

    const mutedIdsDictionary = {};
    for (let index = 0; index < mutedIdsloaded.length; index++) {
      const eventKey = mutedIdsloaded[index];
      mutedIdsDictionary[eventKey] = eventKey;
    }

    setMutedIdsDict(mutedIdsDictionary);
    setMutedFixturesLoaded(true);
    return mutedIdsDictionary;
  }

  async function fetchBlockedFixtures() {
    let getBlockedFixturesEndpoint = `/api/v2/panel/filters/fixtures/blocked`;
    let response = await getData(
      getBlockedFixturesEndpoint,
      { Authorization: getAuthorizationHeader() },
      null,
      abortController ? { signal: abortController.signal } : null
    );

    const blockedIdsDictionary = {};
    if (response != null) {
      for (let index = 0; index < response.data.length; index++) {
        const blockedFixture = response.data[index];
        blockedIdsDictionary[`${blockedFixture.provider_id}:${blockedFixture.fixture_id}`] =
          blockedFixture.status == "blocked";
      }
    }

    setBlockedFixturesDict(blockedIdsDictionary);
    return blockedIdsDictionary;
  }

  async function mutedSwitch(e, mute) {
    e.preventDefault();
    setAllSelected(false);
    setUpdateEnabled(false);
    setOutrightSelected(false);
    setHiddenColumns([]);

    for (let index = 0; index < currentData.rows.length; index++) {
      const dataRow = currentData.rows[index];
      dataRow.selected = false;
    }
    setSelectedRows([]);
    if (mute) {
      currentData = mutedFixtures ? { ...mutedFixtures } : currentData;
    } else {
      currentData = unmutedFixtures ? { ...unmutedFixtures } : currentData;
    }

    changeSorting(currentData);

    setMutedSelected(mute);
    setHiddenColumns(["selected", "checkedOdds", "uncheckedOdds", "diffsOdds"]);
  }

  async function outrightsSwitch(e) {
    e.preventDefault();
    setAllSelected(false);
    setUpdateEnabled(false);
    setMutedSelected(false);
    setDataTableData({ columns: [], rows: [] });

    for (let index = 0; index < currentData.rows.length; index++) {
      const dataRow = currentData.rows[index];
      dataRow.selected = false;
    }
    setSelectedRows([]);
    currentData = outrightsFixtures ? { ...outrightsFixtures } : currentData;
    setDataTableData(currentData);
    setOutrightSelected(true);
  }

  async function allSwitch(e, all) {
    e.preventDefault();
    setAllSelected(all);
    setSelectedRows([]);
    setUpdateEnabled(false);
    setOutrightSelected(false);
    setDataTableData({ columns: [], rows: [] });

    for (let index = 0; index < currentData.rows.length; index++) {
      const dataRow = currentData.rows[index];
      dataRow.selected = false;
    }

    currentData = { ...allTableData };
    setDataTableData(currentData);
  }

  async function getSettlementConfig() {
    let getSettlementsConfig = `/api/v1/bets/settlements/config`;
    let settlementConfigResult = await getData(
      getSettlementsConfig,
      {
        Authorization: getAuthorizationHeader(),
      },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    if (settlementConfigResult != null) {
      setWorkflow(settlementConfigResult.data[0].status);
    }
  }

  async function setSettlementConfig(status) {
    let getSettlementsConfig = `/api/v1/bets/settlements/config`;
    let settlementConfigResult = await postData(
      getSettlementsConfig,
      { functionality: "confirmation", status: status },
      {
        Authorization: getAuthorizationHeader(),
      },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    if (settlementConfigResult != null) {
      setWorkflow(settlementConfigResult.data[0].status);
    }
  }

  function checkedDiffs({ row }) {
    return checkedFixtures[row.original.fixture_id];
  }

  function uncheckedDiffs({ row }) {
    return uncheckedFixtures[row.original.fixture_id];
  }

  function linkCell({ value, ...rest }) {
    return (
      <>
        <HtmlTooltip
          placement="right"
          title={
            <React.Fragment>
              <div
                style={{
                  display: rest.row.original.already_settled ? "flex" : "none",
                  flexWrap: "wrap",
                  color: "orange",
                }}
              >
                Already Settled odd
              </div>
              <div
                style={{
                  display: rest.row.original.fast_market ? "flex" : "none",
                  flexWrap: "wrap",
                  color: "orange",
                }}
              >
                Fast Market
              </div>
              <div
                style={{
                  display: rest.row.original.players_market ? "flex" : "none",
                  flexWrap: "wrap",
                  color: "orange",
                }}
              >
                Players Market
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                Conflicts: {rest.row.original.moderate}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                Unconfirmed: {rest.row.original.toConfirm}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                Must re-Confirm: {rest.row.original.sent}
              </div>
              <hr style={{ marginTop: "5px", marginBottom: "5px" }} />
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                Unsettled Bet Odds: {rest.row.original.unsettled_odds}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                Checked Bet Odds:{" "}
                {checkedFixtures[rest.row.original.fixture_id]
                  ? checkedFixtures[rest.row.original.fixture_id]
                  : 0}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                Not Checked Bet Odds: {uncheckedFixtures[rest.row.original.fixture_id]}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                Diffs from last check: {rest.row.original.diffsOdds}
              </div>
            </React.Fragment>
          }
        >
          <Button onClick={(e) => handleEditOpenModal(e, rest)}>
            <SoftTypography
              component="span"
              variant="button"
              fontWeight="regular"
              color={"info"}
              opacity={0.8}
              sx={{
                lineHeight: 0,
                color:
                  rest.row.original.diffsOdds < 0
                    ? "green"
                    : rest.row.original.diffsOdds > 0
                    ? "red"
                    : "",
              }}
            >
              {value}
              <Icon
                style={{
                  display: rest.row.original.fast_market ? "" : "none",
                  color: "forestgreen",
                }}
              >
                bolt_outlined_icon
              </Icon>
              <Icon
                style={{
                  display: rest.row.original.players_market ? "" : "none",
                  color: "forestgreen",
                }}
              >
                directions_run_outlined_icon
              </Icon>
              <Icon style={{ display: rest.row.original.moderate ? "" : "none" }}>person_icon</Icon>
              <Icon style={{ display: rest.row.original.toConfirm ? "" : "none" }}>
                security_icon
              </Icon>
              <Icon style={{ display: rest.row.original.sent ? "" : "none", color: "orange" }}>
                policy_icon
              </Icon>
              <Icon
                style={{
                  display: rest.row.original.already_settled ? "" : "none",
                  color: "orange",
                }}
              >
                warning_amber_icon
              </Icon>
              <Icon
                style={{
                  display: rest.row.original.noteExist ? "" : "none",
                  color: "orange",
                }}
              >
                edit_note_icon
              </Icon>
            </SoftTypography>
          </Button>
        </HtmlTooltip>
      </>
    );
  }

  function renderDate({ value, ...rest }) {
    let dateformatted = formatDate(value);
    return (
      <div style={{ maxWidth: "100px", overflowWrap: "break-word" }}>
        <span>{dateformatted}</span>{" "}
        <HtmlTooltip
          className="white-html-tooltip"
          placement="right"
          title={
            <React.Fragment>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  maxWidth: "200px",
                  flexDirection: "columns",
                }}
              >
                <div style={{ width: "max-content" }}>StartDates Info:</div>
                {rest.row.original.providerInfo.map((provider, index) => {
                  return (
                    <div
                      key={provider.pid + "-" + index}
                      style={{ display: "flex", width: "fit-content" }}
                    >
                      <div style={{ display: "flex", width: "fit-content" }}>
                        <span className={"provider-" + provider.provider}>
                          {provider.provider}:{" "}
                        </span>
                        {"  "}
                        <span>{formatDate(provider.startDate)}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          }
        >
          <span
            style={{
              display: rest.row.original.start_dates.length > 1 ? "" : "none",
              cursor: "pointer",
            }}
            className="matched"
          >
            {" "}
            *
          </span>
        </HtmlTooltip>
      </div>
    );
  }

  function formatDate(value) {
    let date = new Date(value * 1);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    let timezone = (date.getTimezoneOffset() * -1) / 60;
    timezone = timezone > 0 ? "+" + timezone : timezone;
    return dateformatted;
  }

  function openAdvancedSearch(e, data) {
    e.preventDefault();

    window.open("/settlement/advanced?" + data[0] + "=" + data[1] + "&" + data[2] + "=" + data[3]);
  }

  function matchedRender({ value, ...rest }) {
    let matched = rest.row.original.matched;
    let linked = rest.row.original.linked;
    let sportRadar = rest.row.original.sportradar_id * 1;

    return (
      <Grid className="cur-stlmnt-actions" sx={{ width: "100%", textAlign: "right !important" }}>
        <Grid>
          <div className={matched ? "matched" : "unmatched"}>
            <Button
              className={matched ? "matched" : "unmatched"}
              onClick={(e) =>
                openAdvancedSearch(
                  e,
                  matched
                    ? ["uni_id", value, "sport_id", rest.row.original.sport_id]
                    : ["provider_id", value, "sport_id", rest.row.original.sport_id]
                )
              }
            >
              {value}
            </Button>
            <Icon
              style={{ cursor: "pointer" }}
              className="info-icon"
              onClick={() => handleUUIDCopy(value)}
            >
              copy
            </Icon>

            <HtmlTooltip
              className="white-html-tooltip"
              placement="right"
              title={
                <React.Fragment>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      maxWidth: "200px",
                      flexDirection: "columns",
                      backgroundColor: "#e9ecef",
                      color: "#000",
                      borderColor: "#e9ecef",
                    }}
                  >
                    Linked EventId: {linked}
                  </div>
                </React.Fragment>
              }
            >
              <Button style={{ display: linked ? "" : "none" }} className={linked ? "linked" : ""}>
                <Icon>link_icon</Icon>
              </Button>
            </HtmlTooltip>
          </div>
        </Grid>
        <Grid>
          <div style={{ textAlign: "right" }}>
            <HtmlTooltip
              className="white-html-tooltip"
              placement="right"
              title={
                <React.Fragment>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      maxWidth: "200px",
                      flexDirection: "columns",
                      backgroundColor: "#e9ecef",
                      color: "#000",
                      borderColor: "#e9ecef",
                    }}
                  >
                    SportRadar Timeline
                  </div>
                </React.Fragment>
              }
            >
              <Button
                style={{ display: sportRadar ? "" : "none" }}
                className={sportRadar ? "sportRadar warning-icon" : ""}
                onClick={(e) => {
                  openSportRadarTimeline(e, sportRadar, rest.row.original);
                }}
              >
                <Icon>toc_outlined_icon</Icon>
              </Button>
            </HtmlTooltip>

            <HtmlTooltip
              className="white-html-tooltip"
              placement="right"
              title={
                <React.Fragment>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      maxWidth: "200px",
                      flexDirection: "columns",
                      backgroundColor: "#e9ecef",
                      color: "#000",
                      borderColor: "#e9ecef",
                    }}
                  >
                    Scoreboard
                  </div>
                </React.Fragment>
              }
            >
              <Button
                style={{}}
                className={"sportRadar success-icon"}
                onClick={(e) => {
                  openScoreBoardW(e, rest.row.original);
                }}
              >
                <Icon>content_paste_search_icon</Icon>
              </Button>
            </HtmlTooltip>
          </div>
        </Grid>
      </Grid>
    );
  }

  function formatCell({ value }) {
    return <div className="cell-width">{value}</div>;
  }

  function formatStatusTime({ value, ...rest }) {
    let minFinished = null;
    let hours = "";
    let minutes = "";
    let timestamp =
      rest.row.original.status === "Finished" ? value : rest.row.original.start_date_utc;
    if (timestamp) {
      let now = new Date();
      let finished_at = new Date(timestamp * 1);
      minFinished = now.getTime() - finished_at.getTime();
      minFinished = Math.round(minFinished / 1000 / 60);
      hours = Math.floor(minFinished / 60);
      minutes = minFinished - hours * 60;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
    }

    return (
      <>
        <div
          style={{ display: rest.row.original.status === "In progress" ? "" : "none" }}
          className={rest.row.original.status.replace(/ /g, "_").toLowerCase()}
        >
          {hours}:{minutes} <Icon>slow_motion_video_icon </Icon>
        </div>
        <div
          style={{ display: rest.row.original.status === "In progress" ? "none" : "" }}
          className={rest.row.original.status.replace(/ /g, "_").toLowerCase()}
        >
          {hours}:{minutes}
        </div>
      </>
    );
  }

  function formatParticipant({ value }) {
    return <div style={{ maxWidth: "100px" }}>{value}</div>;
  }

  function formatSport({ value }) {
    return <div style={{ maxWidth: "120px", overflowWrap: "break-word" }}>{value}</div>;
  }

  function formatStatus({ value, ...rest }) {
    return (
      <>
        <div className={value.replace(/ /g, "_").toLowerCase()}>
          <span>{value}</span>
          <HtmlTooltip
            className="white-html-tooltip"
            placement="right"
            title={
              <React.Fragment>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    maxWidth: "200px",
                    flexDirection: "columns",
                    backgroundColor: "#e9ecef",
                    color: "#000",
                    borderColor: "#e9ecef",
                  }}
                >
                  <div style={{ width: "100%" }}>Status Info:</div>
                  {rest.row.original.providerInfo.map((provider, index) => {
                    return (
                      <div
                        key={provider.pid + "-" + index}
                        style={{ display: "flex", width: "fit-content" }}
                      >
                        <div style={{ display: "flex", width: "fit-content" }}>
                          <span className={"provider-" + provider.provider}>
                            {provider.provider}:{" "}
                          </span>
                          {"  "}
                          <span className={provider.status.replace(/ /g, "_").toLowerCase()}>
                            {provider.status}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </React.Fragment>
            }
          >
            <span
              style={{
                display: rest.row.original.statuses.length > 1 ? "" : "none",
                cursor: "pointer",
              }}
              className="matched"
            >
              {" "}
              *
            </span>
          </HtmlTooltip>
        </div>
      </>
    );
  }

  async function openSportRadarTimeline(e, sportRadarId, fixture) {
    e.preventDefault();
    e.stopPropagation();
    setApiresponse("info");
    setApiResponseMsg("Searching for Timeline");
    setNotification(true);
    let getSportRadarTimelineEndpoint = `/api/v1/statistics/timeline?sportRadarId=${sportRadarId}`;
    let response = await getData(
      getSportRadarTimelineEndpoint,
      {
        Authorization: getAuthorizationHeader(),
      },
      null,
      abortController ? { signal: abortController.signal } : null
    );

    if (response != null) {
      if (response.data.length > 0) {
        setTimelineEvent(fixture);
        setSelectedTimeline(response.data);
        handleOpenTimeline(e, fixture);
        setApiresponse("success");
        setApiResponseMsg("Timeline Loaded.");
        setNotification(true);
      } else {
        setApiresponse("error");
        setApiResponseMsg("Timeline not Found");
        setNotification(true);
      }
    }
  }

  async function openScoreBoardW(e, data) {
    e.preventDefault();
    e.stopPropagation();
    setApiresponse("info");
    setApiResponseMsg("Searching for ScoreBoard");
    setNotification(true);
    let providerId = data.providerId;
    let competitionId = data.competition_id;
    let id = data.fixture_id;
    let type = "inplay";
    let sport = data.sport.toLowerCase();

    let getOddsEndpoint = `/api/v1/keys/fixtures/${type}/${sport}`;
    getOddsEndpoint = `${getOddsEndpoint}/${competitionId}/${providerId}/${id}`;

    let response = await getData(
      getOddsEndpoint,
      {
        Authorization: getAuthorizationHeader(),
      },
      null,
      abortController ? { signal: abortController.signal } : null
    );

    if (response != null) {
      if (response.data && response.data.live) {
        setTimelineEvent(data);
        setSelectedScoreboard(response.data.live.scoreBoard);
        handleOpenScoreboard(e, response.data.live.scoreBoard);
        setApiresponse("success");
        setApiResponseMsg("Scoreboad Loaded.");
        setNotification(true);
      } else {
        setApiresponse("error");
        setApiResponseMsg("Scoreboad not Found");
        setNotification(true);
      }
    } else {
    }
  }

  const handleOpenTimeline = (event) => {
    setOpenTimeline(event.target);
  };

  const handleCloseTimeline = () => setOpenTimeline(false);

  const handleOpenScoreboard = (event) => {
    setOpenScoreboard(event.target);
  };

  const handleCloseScoreboard = () => setOpenScoreboard(false);

  // Render the notifications menu
  const renderTimeline = () =>
    selectedTimeline && selectedTimeline.length > 0 ? (
      <Menu
        anchorEl={openTimeline}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={Boolean(openTimeline)}
        onClose={handleCloseTimeline}
        sx={{ mt: 2 }}
        className="timeline-holder"
      >
        <li
          key={timelineEvent.id}
          style={{
            position: "fixed",
            background: "rgb(233, 236, 239)",
            zIndex: 1401,
            borderRadius: "10px",
            padding: "10px",
            minWidth: "280px",
            textAlign: "center",
          }}
        >
          <div>
            <SoftTypography variant="caption" style={{ marginRight: "auto", fontWeight: 700 }}>
              {timelineEvent.sport}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              -
            </SoftTypography>
            <SoftTypography variant="caption" style={{ marginRight: "auto", fontWeight: 700 }}>
              {timelineEvent.provider_name}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              -
            </SoftTypography>
            <SoftTypography variant="caption">{timelineEvent.fixture_id}</SoftTypography>
          </div>
          <div>
            <SoftTypography style={{}} variant="caption">
              {timelineEvent.home}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              Vs
            </SoftTypography>
            <SoftTypography variant="caption">{timelineEvent.away}</SoftTypography>
          </div>
          <DownloadJSON
            data={selectedTimeline}
            fileName={"timeline-events@" + timelineEvent.fixture_id}
          ></DownloadJSON>
        </li>
        <li key={timelineEvent.id + "1"}>&nbsp;</li>
        <li key={timelineEvent.id + "2"}>&nbsp;</li>
        <li key={timelineEvent.id + "3"}>&nbsp;</li>
        <li key={timelineEvent.id + "4"}>&nbsp;</li>
        <li key={timelineEvent.id + "5"}>&nbsp;</li>
        <li key={timelineEvent.id + "6"}>&nbsp;</li>
        {selectedTimeline.map((item) => (
          <HtmlTooltip
            key={item._id}
            placement="right"
            title={
              <React.Fragment>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  more Info for this Timeline-Event:{" "}
                </div>
                {Object.keys(item).map((k, index) => (
                  <div key={item._id + "-" + index + "more_info"}>
                    {k + ": " + (item[k] ? JSON.stringify(item[k]) : "")}
                  </div>
                ))}
              </React.Fragment>
            }
          >
            <NotificationItem
              className={
                item.team == "home"
                  ? "timeline-item-left"
                  : item.team == "away"
                  ? "timeline-item-right"
                  : "timeline-item-middle"
              }
              sx={{ width: "100%" }}
              // image={
              //   <img alt="participant">
              //     {item.team == "home" ? "H" : item.team == "away" ? "A" : ""}
              //   </img>
              // }
              //title={[item.name]}
              info={[item.name]}
              date={item.time == -1 ? null : item.time + "'"}
              side={item.team}
              data={item}
            />
          </HtmlTooltip>
        ))}
      </Menu>
    ) : (
      ""
    );

  const renderScoreboard = () =>
    selectedScoreboard ? (
      <Menu
        anchorEl={openScoreboard}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={Boolean(openScoreboard)}
        onClose={handleCloseScoreboard}
        sx={{ mt: 2 }}
        className="timeline-holder"
      >
        <li
          key={timelineEvent.id}
          style={{
            position: "fixed",
            background: "rgb(233, 236, 239)",
            zIndex: 1401,
            borderRadius: "10px",
            padding: "10px",
            minWidth: "280px",
            textAlign: "center",
          }}
        >
          <div>
            <SoftTypography variant="caption" style={{ marginRight: "auto", fontWeight: 700 }}>
              {timelineEvent.sport}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              -
            </SoftTypography>
            <SoftTypography variant="caption" style={{ marginRight: "auto", fontWeight: 700 }}>
              {timelineEvent.provider_name}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              -
            </SoftTypography>
            <SoftTypography variant="caption">{timelineEvent.fixture_id}</SoftTypography>
          </div>
          <div>
            <SoftTypography style={{}} variant="caption">
              {timelineEvent.home}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              Vs
            </SoftTypography>
            <SoftTypography variant="caption">{timelineEvent.away}</SoftTypography>
          </div>
          <DownloadJSON
            data={[selectedScoreboard]}
            fileName={"scoreboard-events@" + timelineEvent.fixture_id}
          ></DownloadJSON>
        </li>
        <li key={timelineEvent.id + "1"}>&nbsp;</li>
        <li key={timelineEvent.id + "2"}>&nbsp;</li>
        <li key={timelineEvent.id + "3"}>&nbsp;</li>
        <li key={timelineEvent.id + "4"}>&nbsp;</li>
        <li key={timelineEvent.id + "5"}>&nbsp;</li>
        <li key={timelineEvent.id + "6"}>&nbsp;</li>
        <SoftBox
          display=" flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="flex-start"
          p={1}
        >
          <Grid item sm={12} sx={{ width: "100%" }}>
            {selectedScoreboard
              ? Object.keys(selectedScoreboard).map((scItem, i) => {
                  if (
                    !selectedScoreboard[scItem] ||
                    !selectedScoreboard[scItem].hasOwnProperty("h") ||
                    selectedScoreboard[scItem].h == -1
                  )
                    return "";
                  return (
                    <Grid
                      container
                      key={"scoreboard-type-" + i}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "5px",
                        paddingBottom: "15px",
                        backgroundColor: "#ffffff60",
                      }}
                    >
                      <Grid item sm={12}>
                        <SoftTypography className={"scoreboard-type"}>{scItem}</SoftTypography>
                      </Grid>
                      <Grid item sm={12} sx={{ display: "flex" }}>
                        <Grid
                          item
                          sm={6}
                          sx={{ paddingRight: "2px", paddingLeft: "5px", width: "100%" }}
                        >
                          <Grid item sm={12}>
                            <SoftTypography className={"scoreboard-value"}>
                              {selectedScoreboard[scItem].h}
                            </SoftTypography>
                          </Grid>
                          <Grid item sm={12} sx={{ transform: "rotate(180deg)" }}>
                            <SoftProgress
                              className="live-stats-bars"
                              style={{
                                height: "5px",
                                backgroundColor: "#ffffff80",
                              }}
                              variant="contained"
                              color="info"
                              value={
                                selectedScoreboard[scItem].h > 0
                                  ? (100 * selectedScoreboard[scItem].h) /
                                    (selectedScoreboard[scItem].h + selectedScoreboard[scItem].g)
                                  : 0
                              }
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          sm={6}
                          sx={{ paddingLeft: "2px", paddingRight: "5px", width: "100%" }}
                        >
                          <Grid item sm={12}>
                            <SoftTypography className={"scoreboard-value"}>
                              {selectedScoreboard[scItem].g}
                            </SoftTypography>
                          </Grid>
                          <Grid item sm={12}>
                            <SoftProgress
                              style={{
                                height: "5px",
                                backgroundColor: "#ffffff80",
                              }}
                              variant="contained"
                              color="success"
                              value={
                                selectedScoreboard[scItem].g > 0
                                  ? (100 * selectedScoreboard[scItem].g) /
                                    (selectedScoreboard[scItem].h + selectedScoreboard[scItem].g)
                                  : 0
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })
              : ""}
          </Grid>
        </SoftBox>
      </Menu>
    ) : (
      ""
    );
  /**
   *
   * @param {*} update
   * @param {*} name
   */
  const handleEditOpenModal = (e, rowData) => {
    e.preventDefault();
    const fallbackFixtureId =
      rowData?.row?.allCells?.length > 0
        ? rowData.row.allCells[rowData.row.allCells.length - 1].value
        : undefined;
    const selectedFixtureId = rowData?.row?.original?.fixture_id ?? fallbackFixtureId;
    const sourceRows = Array.isArray(rowData?.data)
      ? rowData.data
      : Array.isArray(currentData?.rows)
      ? currentData.rows
      : [];

    let selectedItem = sourceRows.find((item) => item.fixture_id == selectedFixtureId);

    if (!selectedItem && rowData?.row?.original) {
      selectedItem = rowData.row.original;
    }

    if (!selectedItem) {
      return;
    }

    const selectedSport = sportsList?.find((item) => item.id === selectedItem.sport_id);
    if (selectedSport?.name) {
      selectedItem.sport = selectedSport.name;
    }

    selectedItem.providerId = selectedItem.matched ? 1000 : selectedItem.providerId;
    setRowDataSelected(selectedItem);
    setEditModal(true);
  };

  /**
   *
   * @param {*} update
   */
  const handleEditCloseModal = async (update) => {
    if (!rowDataSelected) return;
    if (
      uncheckedFixtures[rowDataSelected.fixture_id] &&
      uncheckedFixtures[rowDataSelected.fixture_id] > 0
    ) {
      checkedFixtures[rowDataSelected.fixture_id] = rowDataSelected.unsettled_odds;
      uncheckedFixtures[rowDataSelected.fixture_id] = 0;
      rowDataSelected.diffsOdds = 0;
    }

    if (update && autoRefresh) {
      setRowDataSelected(null);
      //console.log("Creation completed, please Update!");
      handleSportChange(sportSelected.id, sport);
    } else {
      setRowDataSelected(null);
      //console.log("Creation canceled, do nothing!");
    }
    setEditModal(false);
  };

  const handleConfirmWorkflow = (e) => {
    e.preventDefault();

    let confirmation_config = !workflow;
    setWorkflow(confirmation_config);

    setSettlementConfig(confirmation_config);
  };

  const handleUpdate = (e, status) => {
    e.preventDefault();
    if (selectedRows.length > 0) {
      let action = status ? "mute" : "unmute";
      Swal.fire({
        title: `Confirmation`,
        html: `You are going to ${action} </br></br>
          ${selectedRows.length}
          Selected Fixtures. </br></br> Are you Sure?`,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: `Yes, ${action} them!`,
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let mutedFixtures = selectedRows.map((f) => {
            if (f.matched) {
              return "1000:" + f.fixture_id;
            } else {
              return f.provider_name + ":" + f.fixture_id;
            }
          });
          const mutedIdsDictionary = {};
          for (let index = 0; index < mutedFixtures.length; index++) {
            const eventKey = mutedFixtures[index];
            mutedIdsDictionary[eventKey] = eventKey;
          }

          setMutedIdsDict(mutedIdsDictionary);
          //console.log(status, mutedFixtures);
          let setMuteFixtures = status
            ? `/api/v1/bets/mutedFixtures`
            : `/api/v1/bets/unmuteFixtures`;
          let mutedFixturesResult = await postData(setMuteFixtures, mutedFixtures, {
            Authorization: getAuthorizationHeader(),
          });

          fetchFixtures(sportSelected.id, false);

          setSelectedRows([]);
          setUpdateEnabled(false);
        }
      });
    } else {
      //console.log("Nothing have been changed");
    }
  };

  const handleCancelEdit = async () => {
    if (selectedRows.length > 0) {
      Swal.fire({
        title: `Unsaved Data!`,
        html:
          "You are going to cancel </br></br>" +
          selectedRows.length +
          " Selected Fixtures to mute. </br></br> Are you Sure?",
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes, Cancel them!",
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setUpdateEnabled(false);
          setHiddenColumns([]);
          console.log("handleCancelEdit");
          let dataRows = currentData.rows;

          for (let index = 0; index < dataRows.length; index++) {
            const dataRow = dataRows[index];
            dataRow.selected = false;
          }
          setSelectedRows([]);

          if (dataRows.filter((dr) => dr.selected).length > 0) setUpdateEnabled(true);

          changeSorting(currentData);
        }
      });
    } else {
      //console.log("Nothing have been changed");
    }
  };

  const handleClose = (event, reason) => {
    void event;
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  /**
   *
   */
  const handleUUIDCopy = (UUID) => {
    //console.log("Copy ApiKey: ", apikey);
    copyToClipboard(UUID);
  };

  const copyToClipboard = (textToCopy) => {
    setApiresponse("success");
    setApiResponseMsg("Value has been copied to the clipboard!");
    setNotification(true);
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  useEffect(() => {
    changeSorting();
  }, [sortByUnchecked]);

  useEffect(() => {
    if (providers) {
      setProvidersList(providers);
      // console.log(providers);
    }
  }, [providers]);

  useEffect(() => {
    if (sports) {
      sportsList = sports;
    }
  }, [sports]);

  useEffect(() => {
    return () => {
      if (abortController) {
        // console.log("abortController current settlement");
        abortController.abort();
      }
    };
  }, []);

  useEffect(() => {
    if (
      permissions.length > 0 &&
      (permissions.indexOf("settlement-manager") > -1 || permissions.indexOf("super") > -1)
    ) {
      setSettlementManager(true);
    }
  }, [permissions]);

  useEffect(() => {
    if (fixturesLoaded && mutedFixturesLoaded) {
      if (mutedSelected) mutedSwitch(new Event("mute"), true);
      if (allSelected) allSwitch(new Event("all"), true);
      if (!mutedSelected && !outrightSelected && !allSelected)
        mutedSwitch(new Event("unmute"), false);
    }
  }, [fixturesLoaded, mutedFixturesLoaded]);

  useEffect(() => {
    if (fixturesLoaded && mutedFixturesLoaded && outrightsLoaded) {
      if (outrightSelected) outrightsSwitch(new Event("outright"));
    }
  }, [outrightsLoaded]);

  useEffect(() => {
    if (sportSelected && providers) fetchFixtures(sportSelected.id, true);
  }, [sportSelected, providers]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {renderTimeline()}
      {renderScoreboard()}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"topright"}
        open={notification}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={`${apiResponse}`}
          sx={{ width: "100%" }}
          className={`api-${apiResponse}-notifications`}
        >
          {apiResponseMsg}
        </Alert>
      </Snackbar>
      <EditSettlement
        showModal={showEditModal}
        signalCloseModal={handleEditCloseModal}
        data={rowDataSelected}
      ></EditSettlement>
      <SoftBox my={3} sx={{ marginBottom: "0px" }}>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          p={3}
          sx={{ paddingTop: "0px", paddingRight: "0px" }}
        >
          <SoftBox mt={0} className="settlement-page-holder">
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                lg={sidenavCollapse ? 1 : 3}
                sx={{ width: sidenavCollapse ? "auto" : "250px !important" }}
                className="secondary-menu-fixed-settlement"
              >
                <Sidenav
                  disabled={fetching}
                  sportData={[]}
                  informParent={handleSportChange}
                  sidenavCollapse={handleSideNavCollapse}
                />
              </Grid>
              <Grid
                item
                xs={12}
                lg={sidenavCollapse ? 11 : 9}
                sx={{ marginLeft: sidenavCollapse ? "120px !important" : "260px !important" }}
                className="scrolling-main-page-settlement"
              >
                <SoftBox mb={3}>
                  <Grid container spacing={0}>
                    <Card style={{ width: "100%" }}>
                      <Grid item xs={12} sx={{ paddingTop: "0px", height: "100%" }}>
                        <SoftBox
                          display="flex"
                          justifyContent="space-between"
                          alignItems="flex-start"
                          pt={2}
                          pl={3}
                          pr={3}
                        >
                          <SoftBox lineHeight={1}>
                            <SoftTypography variant="h5" fontWeight="medium">
                              {sportSelected ? sportSelected.name : ""}
                            </SoftTypography>
                            <SoftTypography variant="button" fontWeight="regular" color="text">
                              Here you can find all the <b>current</b>{" "}
                              <span style={{ color: "#cb0c9f" }}>Unsettled bets</span> for each
                              Fixture of the selected Sport
                            </SoftTypography>
                            <Button
                              className={sortByUnchecked ? "sort" : "unsort"}
                              onClick={setSortBy}
                            >
                              {sortByUnchecked ? "Sort by New Odds - ON" : "Sort by New Odds - OFF"}
                            </Button>
                          </SoftBox>
                          <SoftBox sx={{ display: settlementManager ? "" : "none" }}>
                            <ToggleButtonGroup
                              value={workflow}
                              exclusive
                              onChange={handleConfirmWorkflow}
                              aria-label="text alignment"
                            >
                              <ToggleButton
                                className={
                                  workflow == undefined
                                    ? "workflow_undefined"
                                    : workflow
                                    ? "workflow_enabled"
                                    : "workflow_disabled"
                                }
                                value={true}
                                aria-label="Enable/Disable Confirmation Workflow"
                              >
                                {workflow == undefined
                                  ? "Confirmation Workflow"
                                  : workflow
                                  ? "Confirmation Workflow - ON"
                                  : "Confirmation Workflow - OFF"}
                              </ToggleButton>
                            </ToggleButtonGroup>
                            <Button
                              className={autoRefresh ? "sort" : "unsort"}
                              onClick={setAutorefreshValue}
                            >
                              {autoRefresh ? "AutoRefresh - ON" : "AutoRefresh - OFF"}
                            </Button>
                          </SoftBox>
                          <Stack
                            spacing={1}
                            direction="row"
                            className="live-table-refresh"
                            sx={{ top: "130px !important" }}
                          >
                            <Button
                              alt="Manually Refresh Data"
                              onClick={() =>
                                sportSelected ? handleSportChange(sportSelected.id, sport) : null
                              }
                              disabled={showRefreshButton == false}
                              className={showRefreshButton == false ? "show-disable-pointer" : ""}
                            >
                              <Icon>refresh</Icon>
                            </Button>
                          </Stack>
                        </SoftBox>
                        <SoftBox
                          p={3}
                          sx={{
                            paddingTop: "0px !important",
                            paddingBottom: "0px !important",
                            zIndex: 3,
                          }}
                        >
                          <Grid container>
                            <Grid item xs={6} md={6} style={{ textAlign: "left" }}>
                              <Button
                                className={
                                  allSelected || outrightSelected
                                    ? "switch-unmuted"
                                    : mutedSelected
                                    ? "switch-unmuted"
                                    : "switch-muted"
                                }
                                onClick={(e) => mutedSwitch(e, false)}
                              >
                                Unmuted (
                                {unmutedFixtures && unmutedFixtures.rows
                                  ? unmutedFixtures.rows.length
                                  : 0}
                                )
                              </Button>
                              <Button
                                className={
                                  allSelected || outrightSelected
                                    ? "switch-unmuted"
                                    : mutedSelected
                                    ? "switch-muted"
                                    : "switch-unmuted"
                                }
                                onClick={(e) => mutedSwitch(e, true)}
                              >
                                Muted (
                                {mutedFixtures && mutedFixtures.rows
                                  ? mutedFixtures.rows.length
                                  : 0}
                                )
                              </Button>
                              <Button
                                className={allSelected ? "switch-muted" : "switch-unmuted"}
                                onClick={(e) => allSwitch(e, true)}
                              >
                                All
                              </Button>
                              <Button
                                className={outrightSelected ? "switch-muted" : "switch-unmuted"}
                                onClick={(e) => outrightsSwitch(e)}
                              >
                                Outrights (
                                {outrightsFixtures && outrightsFixtures.rows
                                  ? outrightsFixtures.rows.length
                                  : 0}
                                )
                              </Button>
                            </Grid>
                            <Grid item xs={6} md={6} style={{ textAlign: "right" }}>
                              <SoftBox
                                lineHeight={1}
                                sx={{ display: oddSettingsEditCached ? "" : "none" }}
                              >
                                <Button
                                  onClick={handleCancelEdit}
                                  disabled={updateEnabled ? false : true}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  onClick={(e) => handleUpdate(e, true)}
                                  disabled={
                                    updateEnabled
                                      ? allSelected
                                        ? false
                                        : mutedSelected
                                        ? true
                                        : false
                                      : true
                                  }
                                >
                                  Mute
                                </Button>
                                <Button
                                  onClick={(e) => handleUpdate(e, false)}
                                  disabled={
                                    updateEnabled
                                      ? allSelected
                                        ? false
                                        : mutedSelected
                                        ? false
                                        : true
                                      : true
                                  }
                                >
                                  Unmute
                                </Button>
                              </SoftBox>
                            </Grid>
                          </Grid>
                        </SoftBox>

                        <DataTable
                          table={dataTableData}
                          bodyClassName="settlement-fixtures-list"
                          entriesPerPage={{
                            defaultValue: 10,
                            entries: [5, 10, 15, 20, 25, 30],
                          }}
                          hiddenColumns={hiddenColumns}
                          autoResetPageDefault={false}
                          autoResetGlobalFilter={true}
                          autoResetSortByDefault={false}
                          canSearch
                          checkboxSelection={oddSettingsEditCached}
                          informParent={handleTableDataChanges}
                        ></DataTable>
                      </Grid>
                    </Card>
                  </Grid>
                </SoftBox>
              </Grid>
            </Grid>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

export default Settlement;
